import React, { useEffect, useState } from 'react';
import { Row, Col, Button, Alert } from 'react-bootstrap';
import { FaFilePdf, FaFileAlt } from 'react-icons/fa';
import { toast } from 'react-toastify';
import Loading from '~/Components/Loading';
import { obterDocumentoDigitalCessaoPorPreVenda } from '~/Services/Service';

const VisualizarTermo = ({ preVenda }) => {
  const [documentoDigital, setDocumentoDigital] = useState(null);
  const [isLoadingDocumento, setIsLoadingDocumento] = useState(false);
  const [erro, setErro] = useState(null);

  useEffect(() => {
    carregarDocumentoDigital();
  }, [preVenda]);

  const carregarDocumentoDigital = async () => {
    if (!preVenda) return;
    setIsLoadingDocumento(true);
    setErro(null);
    try {
      const data = await obterDocumentoDigitalCessaoPorPreVenda(preVenda);
      setDocumentoDigital(data);
    } catch (err) {
      setDocumentoDigital(null);
      setErro(err && err.message ? err.message : 'Documento não encontrado');
      console.log('Documento digital não disponível:', err);
    } finally {
      setIsLoadingDocumento(false);
    }
  };

  const abrirDocumentoPDF = () => {
    if (!documentoDigital) {
      toast.warning('Documento não disponível');
      return;
    }

    if (documentoDigital.url_documento) {
      window.open(documentoDigital.url_documento, '_blank');
      return;
    }

    if (documentoDigital.documento_pdf && documentoDigital.documento_pdf.length > 0) {
      try {
        const base64String = documentoDigital.documento_pdf;
        const byteCharacters = atob(base64String);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/pdf' });
        const url = URL.createObjectURL(blob);
        window.open(url, '_blank');
      } catch (err) {
        toast.error('Erro ao abrir o documento PDF');
        console.error('Erro ao processar PDF:', err);
      }
    } else {
      toast.warning('Documento PDF não disponível');
    }
  };

  if (isLoadingDocumento) {
    return (
      <div className="p-4 text-center">
        <Loading />
        <p className="text-muted mt-2">Carregando documento...</p>
      </div>
    );
  }

  if (erro) {
    return (
      <div className="p-4">
        <Alert variant="info">
          <Alert.Heading>Documento não disponível</Alert.Heading>
          <p>
            Não foi encontrado um termo de cessão para esta pré-venda.
          </p>
          <hr />
          <p className="mb-0 text-muted">
            <small>{erro}</small>
          </p>
        </Alert>
      </div>
    );
  }

  return (
    <div className="p-4">
      <h5 className="text-center text-secondary mb-4">
        Termo de Cessão de Transferência
      </h5>
      <Row>
        <Col md={12} className="text-center mb-4">
          <div className="p-4 border rounded bg-light">
            <FaFileAlt size={48} className="text-primary mb-3" />
            <h6 className="mb-3">
              {documentoDigital && documentoDigital.nome_arquivo
                ? documentoDigital.nome_arquivo
                : 'Documento de Cessão'}
            </h6>
            <Button
              variant="primary"
              size="lg"
              onClick={abrirDocumentoPDF}
              disabled={!documentoDigital}
            >
              <FaFilePdf className="mr-2" />
              Visualizar Documento
            </Button>
            <br />
            <small className="text-muted mt-2 d-block">
              {documentoDigital
                ? 'Clique para visualizar o arquivo em nova aba'
                : 'Documento não disponível'}
            </small>
          </div>
        </Col>
      </Row>

      {documentoDigital && (
        <Row className="mt-3">
          <Col md={12}>
            <div className="border rounded p-3 bg-white">
              <h6 className="text-secondary mb-3">Informações do Documento</h6>
              <Row>
                <Col md={4}>
                  <small className="text-muted">Pré-Venda:</small>
                  <br />
                  <strong>
                    {documentoDigital.numero_pre_venda || 'N/A'}
                  </strong>
                </Col>
                <Col md={4}>
                  <small className="text-muted">Status:</small>
                  <br />
                  <strong>
                    {(() => {
                      switch (documentoDigital.status_documento) {
                        case 0: return 'Contrato Físico';
                        case 1: return 'Solicitado';
                        case 2: return 'Aprovado';
                        case 3: return 'Reprovado';
                        case 4: return 'Descartado';
                        case 5: return 'Aguardando Assinatura Cliente';
                        case 6: return 'Aguardando Assinatura Setpar';
                        case 7: return 'Cancelado';
                        case 8: return 'Finalizado';
                        case 9: return 'Enviado';
                        case 10: return 'Implantado';
                        case 11: return 'Gravado';
                        default: return 'Pendente';
                      }
                    })()}
                  </strong>
                </Col>
                <Col md={4}>
                  <small className="text-muted">Código Solicitação:</small>
                  <br />
                  <strong>
                    {documentoDigital.codigo_solicitacao || 'N/A'}
                  </strong>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      )}
    </div>
  );
};

export default VisualizarTermo;
